import React, { useState, useEffect } from 'react';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const ChangePassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [error, setError] = useState('');
  const [token, setToken] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Extract the token from the URL path
    const path = window.location.pathname;
    const tokenFromURL = path.split('/')[2]; // The token is at the 3rd position in the path
    setToken(tokenFromURL);
  }, []);

  const handleNewPasswordChange = (e) => {
    setNewPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if passwords match
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      setSuccessMessage('');
    } else {
      setError('');
      setSuccessMessage('');

      try {
        // Make the API request to reset the password
        const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/reset-password', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            token: token,
            password: newPassword,
          }),
        });

        const data = await response.json();

        if (response.ok) {
          setSuccessMessage('Password changed successfully! Please Login');
          setTimeout(() => {
            navigate('/login'); // Redirect to the login page
          }, 3000);
          setNewPassword('');
          setConfirmPassword('');
        } else {
          setError(data.message || 'Something went wrong!');
        }
      } catch (err) {
        setError('Failed to reset password. Please try again.');
      }
    }
  };

  return (
    <Container className="mt-5">
      <div className="text-center mb-4">
        <img
          src="https://aksharafinalytics.com/wp-content/uploads/elementor/thumbs/akfin-qgepick2gc4b4m3xfynr658qlgki21rx8vyqzuu9ys.png"
          alt="Logo"
          style={{ maxWidth: '150px' }}
        />
      </div>

      {successMessage && <Alert variant="success" className="mb-2">{successMessage}</Alert>}
      {error && <Alert variant="danger" className="mb-2">{error}</Alert>}

      <Card className="shadow" style={{ maxWidth: '500px', margin: '0 auto' }}>
        <Card.Header>
          <h4>Change Password</h4>
        </Card.Header>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="newPassword" className="mb-3">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                value={newPassword}
                onChange={handleNewPasswordChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="confirmPassword" className="mb-3">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type="password"
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
                required
              />
            </Form.Group>

            <div className="text-center">
              <Button type="submit" variant="primary">
                Submit
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ChangePassword;
